import type { PhysicalThing } from "../../engine/physicalThing";
import type { EffectManager } from "../effectManager";
import { resolveEntityVisualCell } from "../movementInterpolation";

/**
 * Resolves an entity's current visual position in fractional board coordinates,
 * accounting for active movement effects. Used by the particle system to emit
 * particles at the correct position of moving entities (e.g., missile exhaust
 * during flight animation), and by the darkness overlay to follow the player.
 */
export function resolveEntityBoardPosition(
	entity: PhysicalThing,
	preEffectsManager?: EffectManager,
	posEffectsManager?: EffectManager,
): { x: number; y: number } {
	const cell = resolveEntityVisualCell(entity, [preEffectsManager, posEffectsManager]);
	return cell ?? { x: entity.xy.x, y: entity.xy.y };
}
